'use client';

import {Body} from '@/components/body';
import {Heading} from '@/components/heading';
import {Button} from '@/components/ui/button';
import Link from 'next/link';
import AutoScroll from 'embla-carousel-auto-scroll';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '@/components/ui/carousel';

const STRIP_ITEMS = [
  'Fonti certe e personalizzabili',
  'Codice dei Contratti 36/2023',
  'Linee guida ANAC aggiornate',
  'Giurisprudenza TAR / CdS',
  'Redazione atti di gara',
  'Fonti certe e personalizzabili',
  'Codice dei Contratti 36/2023',
  'Linee guida ANAC aggiornate',
  'Giurisprudenza TAR / CdS',
  'Redazione atti di gara',
];

export default function MainBannerAppalti() {
  return (
    <div className="w-full md:px-8">
      <div className="bg-background-2 flex flex-col items-center justify-center md:rounded-lg min-h-[65svh]">
        <div className="flex flex-col justify-center items-center text-center gap-8 py-16 px-4 md:px-0">
          <Heading variant="h1" className="max-w-[56.625rem]">
            L&apos;assistente di intelligenza artificiale per le{' '}
            <span className="rounded-[2rem] rounded-br-[8px] py-0 px-2 md:px-4 bg-secondary text-primary">
              stazioni appaltanti
            </span>{' '}
            e la gestione degli appalti pubblici
          </Heading>
          <Body variant="large" className="max-w-[42rem]">
            Ricerca normativa e giurisprudenziale, analisi di atti e documenti,
            supporto alla redazione di bozze, pareri, navigazione del D.Lgs.
            36/2023, analisi normativa e delibere ANAC, redazione atti di gara,
            verifica conformità, definizione CCNL di riferimento. Meno tempo
            perso nelle attività ripetitive, più tempo per strategia.
          </Body>
          <div className="flex flex-col md:flex-row items-center justify-center gap-4">
            <Link href={`${process.env.NEXT_PUBLIC_NAI_APP_URL}/sign-up`}>
              <Button variant="default" size="default">
                Attiva la Prova Gratuita
              </Button>
            </Link>
          </div>
        </div>

        <div className="w-full border-t border-border py-4 relative overflow-hidden">
          <Carousel
            opts={{loop: true}}
            plugins={[
              AutoScroll({
                direction: 'forward',
                speed: 0.8,
                stopOnInteraction: false,
              }),
            ]}
          >
            <CarouselContent>
              {STRIP_ITEMS.map((item, index) => (
                <CarouselItem key={index} className="basis-auto">
                  <div className="flex items-center gap-3 px-4">
                    <span className="text-secondary font-bold text-lg">→</span>
                    <Body variant="bold" className="whitespace-nowrap">
                      {item}
                    </Body>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
          <div className="absolute inset-0 bg-gradient-to-r from-background-2 via-transparent to-background-2 pointer-events-none" />
        </div>
      </div>
    </div>
  );
}
